import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import staticContent from "../seo/StaticContent.mjs";
import "../styles/user/SeoContent.css";

export default function GuidePage({ guide }) {
  const { GuideArticle } = staticContent;
  const { hash } = useLocation();
  useEffect(() => {
    const section = hash ? document.getElementById(hash.slice(1)) : null;
    if (section) section.scrollIntoView();
    else window.scrollTo(0, 0);
  }, [guide.path, hash]);
  return <><Header /><main className="seo-guide-main"><GuideArticle guide={guide} /></main><Footer /></>;
}
